// Material UI Imports
import { keyframes, SvgIcon } from "@mui/material";

// SVG Imports
import LogoSVG from "@/svgs/pulse_prime_logo.svg?react";

const glow = keyframes`
  0% {
    filter: drop-shadow(0 0 15px rgba(88, 143, 235, 1));
  }
  50% {
    filter: drop-shadow(0 0 22.5px rgba(88, 143, 235, 1));
  }
  100% {
    filter: drop-shadow(0 0 15px rgba(88, 143, 235, 1));
  }
`;

const AGLoadingOverlay = () => {
  return (
    <div
      className="pulse-bg-color--background-800"
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
      }}
    >
      <SvgIcon
        sx={{
          width: "50%",
          height: "50%",
          position: "absolute",
          top: "25%",
          left: "25%",
          animation: `${glow} 1.5s infinite ease-in-out`,
          transition: "filter 0.3s",
          "&:hover": {
            filter: "drop-shadow(0 0 15px rgba(0, 102, 204, 0.9))",
          },
        }}
        children={
          <LogoSVG className="pulse-color--background-800 glowing-svg" />
        }
      />
    </div>
  );
};

export default AGLoadingOverlay;
